export const GET_DASHBOARD = "GET_DASHBOARD"
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS"

export const DASHBOARD_REQUEST_ERROR = "DASHBOARD_REQUEST_ERROR";
export const CLEAR_DASHBOARD = "CLEAR_DASHBOARD";
export const CLEAR_ERROR = "CLEAR_DASHBOARD_ERROR";

export const TOGGLE_PROCESSING = "TOGGLE_DASHBOARD_PROCESSING";